type PolicyStepBarProps = {
  steps: string[];
  current: number;
};

export const PolicyStepBar = ({ steps, current }: PolicyStepBarProps) => (
  <div className="border-b border-[#33b864]/15 bg-white px-4 sm:px-6 py-3" data-testid="boost-stepper">
    {/* Mobile: compact dots + "Step X of Y" */}
    <div className="flex sm:hidden items-center justify-between">
      <div className="flex items-center gap-1.5">
        {steps.map((_, i) => {
          const idx = i + 1;
          const done = idx < current;
          const active = idx === current;
          return (
            <div
              key={idx}
              className={[
                'h-2 rounded-full transition-all duration-300',
                active ? 'w-6 bg-[#33b864]' : done ? 'w-2 bg-[#33b864]' : 'w-2 bg-gray-200',
              ].join(' ')}
            />
          );
        })}
      </div>
      <span className="text-xs font-medium text-gray-500">
        Step {current} of {steps.length}
        {steps[current - 1] && <span className="text-[#33b864]"> · {steps[current - 1]}</span>}
      </span>
    </div>

    {/* Desktop: full labeled stepper */}
    <div className="hidden sm:flex max-w-5xl mx-auto items-center justify-center">
      <div className="flex items-center gap-2">
        {steps.map((label, i) => {
          const idx     = i + 1;
          const done    = idx < current;
          const active  = idx === current;
          const pending = idx > current;
          return (
            <div key={idx} className="flex items-center gap-2">
              <div className="flex flex-col items-center gap-1">
                <div
                  className={[
                    'h-7 w-7 rounded-full flex items-center justify-center text-xs font-semibold transition-all duration-300',
                    done    ? 'bg-[#33b864] text-white'                                     : '',
                    active  ? 'bg-[#33b864] text-white ring-2 ring-[#33b864]/30 scale-110' : '',
                    pending ? 'bg-gray-100 text-gray-400 border border-gray-200'            : '',
                  ].join(' ')}
                >
                  {done ? '✓' : idx}
                </div>
                <span
                  className={[
                    'text-[10px] font-medium whitespace-nowrap',
                    active ? 'text-[#33b864]' : 'text-gray-400',
                  ].join(' ')}
                >
                  {label}
                </span>
              </div>
              {i < steps.length - 1 && (
                <div className="w-10 h-px bg-gray-200 mb-4 relative">
                  <div
                    className="absolute inset-y-0 left-0 bg-[#33b864] transition-all duration-500"
                    style={{ width: current > idx ? '100%' : '0%' }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  </div>
);
